<div class="status-container">
  <div class="status-badge" [ngClass]="statusClass">
    <div class="status-icon">
      <app-icon *ngIf="decision ==='Refusée'" type="fa" icon="times-circle" class="warn" size="20">
      </app-icon>
      <app-icon *ngIf="decision ==='Acceptée'" type="fa" icon="check-circle" class="success-color" size="20">
      </app-icon>
      <app-icon *ngIf="decision ==='Abandon'" type="fa" icon="trash" size="20"></app-icon>
      <app-icon *ngIf="decision ==='En attente' || decision ===''" type="fa" icon="question-circle" class="accent"
        size="20">
      </app-icon>
      <app-icon *ngIf="decision ==='Partiellement acceptée'" type="fa" icon="check-circle" class="success-color"
        size="20">
      </app-icon>
    </div>
    <div class="status-info">
      <div class="status-text">{{ displayedStatus }}</div>
      @if(statusReason){
      <div class="status-reason">
        {{ statusReason }}
      </div>
      }
    </div>
  </div>
</div>
